import { Delete, Get, Patch, Post } from "./apiHelper";
import { ApiResponse } from "../interfaces/Api";
import { IHoliday } from "../interfaces/HolidayInterface";

const holidayRoot = "/api/holidays";

// get holidays
export async function getHolidays({
  resourceCentreId,
  fiscalYear
}: {
  resourceCentreId: number;
  fiscalYear?: string | number;
}): Promise<ApiResponse<Array<IHoliday>>> {
  const searchParams = new URLSearchParams();
  searchParams.append("resourceCentreId", resourceCentreId.toString());

  if (fiscalYear) searchParams.append("fiscalYear", fiscalYear.toString());

  const response = await Get(`${holidayRoot}?${searchParams.toString()}`, true);
  return response.data as ApiResponse<Array<IHoliday>>;
}

// post holiday
export async function postHoliday(data: Partial<IHoliday>): Promise<ApiResponse<IHoliday>> {
  const response = await Post(`${holidayRoot}`, data as any, true);
  return response.data as ApiResponse<IHoliday>;
}

// patch holiday
export async function patchHoliday({
  id,
  data
}: {
  id: number | string;
  data: Partial<IHoliday>;
}): Promise<ApiResponse<IHoliday>> {
  const response = await Patch(`${holidayRoot}/${id}`, data as any, true);
  return response.data as ApiResponse<IHoliday>;
}

// delete holiday
export async function deleteHoliday(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${holidayRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
